module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-512x512-9efbf96957f5fcb28667953098abd2be.png";